import { useLocation, useRouteError } from 'react-router-dom';
import Button from '~components/Atoms/Button';
import Unescaped from '~components/Atoms/Unescaped';
import GenericErrorPage from '~components/Molecules/GenericErrorPage';
import IntelliProveAPIError from '~services/errors/intelliprove_api_exception';
import { messageService } from '~services/post_message_events';

function ErrorPage() {
  const routeError = useRouteError();
  const location = useLocation();

  let error = routeError;
  if (routeError === undefined || routeError === null) {
    error = location.state?.error;
  }

  if (error === undefined || error === null) {
    error = new Error('Unknown error');
  }

  let title = 'Something went wrong';
  let message = 'Hmm, something unexpected went wrong while loading your health dashboard!';
  let status = 500;

  if (error instanceof IntelliProveAPIError) {
    if (error.status_code === 401) {
      title = 'Missing authentication';
      message = 'Hmm, it looks like we are unable to figure out who you are. You could go back to the previous page and try again.';
      status = 401;
    } else {
      status = error.status_code;
    }
  }

  function close() {
    messageService.userFinishedAndDismiss();
  }

  return (
    <div className="w-screen h-screen bg-neutral-100 p-8 flex flex-col items-center text-surface-surface-error">
      <Button onClick={close} priority="close" content="x" className="self-end" />
      <div className="flex-grow flex flex-col justify-center items-center">
        <h1>{title}</h1>
        <GenericErrorPage status={status} />
        <p className="text-center">
          <Unescaped>{message}</Unescaped>
        </p>
      </div>
    </div>
  );
}

export default ErrorPage;
